/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../reducers';
import { selectList, loadSurveyList } from '../../slice/initiativeSurveyListSlice';
import { ReportSwitcherDropdown, ReportSwitcherDropdownProps } from './ReportSwitcherDropdown';
import './styles.scss';
import classNames from 'classnames';
import { LoadingPlaceholder } from '@g17eco/molecules/loader-container';

export const ReportSwitcherContainer = (props: ReportSwitcherDropdownProps) => {
  const { initiativeId, classes = { container: 'ml-auto' } } = props;
  const { loaded } = useAppSelector(selectList);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (initiativeId) {
      dispatch(loadSurveyList(initiativeId));
    }
  }, [dispatch, initiativeId]);

  return (
    <div className={classNames('report-switcher-container', classes.container)}>
      <LoadingPlaceholder height={38} isLoading={!loaded}>
        <ReportSwitcherDropdown {...props} />
      </LoadingPlaceholder>
    </div>
  );
};
